import API from 'api';
import * as C from './constants';
import receiveNetworkException from './network';
import error from './error';
import * as Models from './models/gallery';

export const loadSuccess = (type, res) => ({
  type,
  ...res,
});

export const load = (params) => (dispatch) => {
  dispatch({ type: C.LOAD_GALLERY });
  return API.gallery.load(params)
    .then(({ body: { data, meta } }) => ({
      data: Models.Gallery(data),
      queryParams: params,
      meta,
    }))
    .then((res) => dispatch(loadSuccess(C.LOAD_GALLERY_SUCCESS, res)))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_GALLERY_ERROR, 'Error loading feedbacks'));
    });
};
